import { Table, TableProps } from "antd";

// interface GenericTableProps<T> extends TableProps<T> {
//   className?: string;
//   onRowClick?: (record: T) => void;
//   loading?: boolean;
//   emptyText?: string;
// }

interface GenericTableProps<T> extends Omit<TableProps<T>, "onRow"> {
  className?: string;
  onRowClick?: (record: T) => void;
  loading?: boolean;
  emptyText?: string;
}

const GenericTable = <T extends object>({
  columns,
  dataSource,
  rowSelection,
  className,
  onRowClick,
  loading = false,
  emptyText,
  ...rest
}: GenericTableProps<T>) => {
  return (
    <Table<T>
      columns={columns}
      dataSource={dataSource}
      rowSelection={rowSelection}
      className={className}
      loading={loading}
      locale={{ emptyText: emptyText || "No data" }}
      onRow={(record) => ({
        onClick: () => onRowClick?.(record),
      })}
      style={{ overflowX: "auto" }}
      {...rest}
    />
  );
};

export default GenericTable;
